import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  cdmrAdd({ commit, dispatch, getters }) {
    return axios.post(`/api/cdmrs/add`).then(response => {
      const cdmr = response.data
      return cdmr
    })
  },

  createCdmr({ commit, dispatch, getters }, { cdmId }) {
    return axios.post(`/api/cdmrs/fromCdm/${cdmId}`).then(response => {
      const cdmr = response.data
      return cdmr
    })
  },

  createPurgeCdmr({ commit, dispatch, getters }, { cdmId }) {
    return axios.post(`/api/cdmrs/fromCdm/${cdmId}/purge`).then(response => {
      const cdmr = response.data
      return cdmr
    })
  },

  createChangeset(
    { commit, dispatch, getters },
    { cdmrId, changeset, comment } = {}
  ) {
    return axios
      .post(`/api/cdmrs/${cdmrId}/changesets`, {
        data: changeset,
        comment: comment,
      })
      .then(response => {
        const changeset = response.data
        return changeset
      })
  },

  approveCdmr({ commit, dispatch, getters }, { cdmrId, comment } = {}) {
    return axios
      .post(`/api/cdmrs/${cdmrId}/approve`, {
        comment: comment,
      })
      .then(response => {
        const changeset = response.data
        return changeset
      })
  },

  getCdmrs({ commit, dispatch, getters }, { queryTerms } = {}) {
    return axios.get('/api/cdmFields').then(response => {
      const fields = response.data
      return axios.get('/api/cdmrs').then(response => {
        const cdmrs = response.data
        return { fields, cdmrs }
      })
    })
  },

  scriptCdmrs({ commit, dispatch, getters }, { token } = {}) {
    return new Promise(function(resolve, reject) {
      var req = new XMLHttpRequest()
      req.open('GET', `${axios.defaults.baseURL}/api/cdmrs/script`, true)
      req.setRequestHeader('Authorization', `${token}`)
      req.responseType = 'blob'
      req.onreadystatechange = function() {
        if (req.readyState === 4 && req.status === 200) {
          // test for IE

          if (typeof window.navigator.msSaveBlob === 'function') {
            window.navigator.msSaveBlob(
              req.response,
              new Date().getTime() + '.csv'
            )
          } else {
            var blob = req.response
            var link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = new Date().getTime() + '.csv'

            // append the link to the document body

            document.body.appendChild(link)

            link.click()
          }

          resolve()
        } else if (req.status !== 200) {
          reject(new Error('An error occurred downloading your file.'))
        }
      }
      req.send()
    })
  },

  getOnlyCdmrs({ commit, dispatch, getters }, { queryTerms } = {}) {
    return axios.get('/api/cdmrs', { params: queryTerms }).then(response => {
      return response.data
    })
  },

  getInbox({ commit, dispatch, getters }, { queryTerms } = {}) {
    return axios
      .get('/api/cdmrs/inbox', { params: queryTerms })
      .then(response => {
        return response.data
      })
  },

  denyCdmr({ commit, dispatch, getters }, { cdmrId, finalComment } = {}) {
    return axios
      .post(`/api/cdmrs/${cdmrId}/deny`, {
        finalComment,
      })
      .then(response => {
        const cdmr = response.data
        return cdmr
      })
  },

  getCdmr({ commit, dispatch, getters }, { cdmrId } = {}) {
    return axios.get('/api/cdmFields').then(response => {
      const fields = response.data

      return axios.get(`/api/cdmrs/${cdmrId}`).then(response => {
        const cdmr = response.data

        return axios.get(`/api/cdmrs/${cdmrId}/changesets`).then(response => {
          const changesets = response.data

          return { cdmr, changesets, fields }
        })
      })
    })
  },
}
